import * as React from 'react';
import * as styles from './styles.css';

export interface IVKVideoProps {
  src: string;
}

export function VKVideo({ src }: IVKVideoProps) {
  return (
    <iframe
      data-testid="VKVideoPlayer"
      className={styles['container']}
      src={`${src}&autoplay=1`}
      allow="autoplay"
      allowFullScreen
    />
  );
}
